/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNinjaOneOrganizationsRequest
 */
export interface GetNinjaOneOrganizationsRequest {
    /**
     * 
     */
    clientId?: string;
    /**
     * 
     */
    clientSecret?: string;
    /**
     * 
     */
    region?: GetNinjaOneOrganizationsRequestRegionEnum;
}


/**
 * @export
 */
export const GetNinjaOneOrganizationsRequestRegionEnum = {
    Eu: 'eu',
    Us: 'us',
    Ca: 'ca',
    Oc: 'oc',
} as const;
export type GetNinjaOneOrganizationsRequestRegionEnum = typeof GetNinjaOneOrganizationsRequestRegionEnum[keyof typeof GetNinjaOneOrganizationsRequestRegionEnum];


/**
 * Check if a given object implements the GetNinjaOneOrganizationsRequest interface.
 */
export function instanceOfGetNinjaOneOrganizationsRequest(value: object): value is GetNinjaOneOrganizationsRequest {
    return true;
}

export function GetNinjaOneOrganizationsRequestFromJSON(json: any): GetNinjaOneOrganizationsRequest {
    return GetNinjaOneOrganizationsRequestFromJSONTyped(json, false);
}

export function GetNinjaOneOrganizationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNinjaOneOrganizationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function GetNinjaOneOrganizationsRequestToJSON(json: any): GetNinjaOneOrganizationsRequest {
    return GetNinjaOneOrganizationsRequestToJSONTyped(json, false);
}

export function GetNinjaOneOrganizationsRequestToJSONTyped(value?: GetNinjaOneOrganizationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'region': value['region'],
    };
}

